import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'text-area-usage',
  templateUrl: './text-area-usage.component.html',
  styleUrls: ['./text-area-usage.component.sass']
})
export class TextAreaUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
